<app-spinner></app-spinner>

<mat-drawer-container class="drawer-container">
  <!-- Sidebar -->
  <mat-drawer #sidebar class="pc-sidebar" [mode]="modeValue" opened style="background-color: #f9f9f9;">
    <nav>
      <div class="navbar-wrapper">
        <div class="m-header">
          <a href="/">
            <!-- Logo o altri contenuti qui -->
          </a>
        </div>
        <app-vertical-menu [menus]="menus"></app-vertical-menu>
      </div>
    </nav>
  </mat-drawer>

  <!-- Contenuto principale -->
  <mat-drawer-content class="drawer-content" >
    <!-- Navbar -->
    <app-nav-bar ></app-nav-bar>

    <!-- Container principale -->
    <div class="app-container">
    
      <!-- Corpo principale della pagina -->
      <div class="main-body">
        <div class="page-wrapper">
          
          <router-outlet></router-outlet>
        </div>
      </div>

      <!-- Footer -->
      <app-footer></app-footer>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
